import { TotalResult } from "../generated-api-proxy";

export class TotalResultViewModel {
  created_at: Date | null = null;
  updated_at!: Date;
  group: number = 1;
  risk: number = 1;
  risk_id: number = 1;
  has_value: boolean = false;

  constructor(totalResult: TotalResult | undefined | null = null) {
    if (totalResult) {
      this.has_value = true;
      this.created_at = totalResult.created_at;
      this.updated_at = totalResult.updated_at;
      this.group = totalResult.group;
      this.risk = totalResult.risk;
      this.risk_id = totalResult.risk_id;
    }
  }

  static empty(): TotalResultViewModel {
    return new TotalResultViewModel();
  }
}
